<!-- 公众号配置模板库 -->
<template>
  <div class="page-box">
    <div style="background-color: #fff; padding: 20px; margin-bottom: 20px">
      <div class="page-title">公众号配置模板库</div>
      <div
        style="
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-top: 17px;
        "
      >
        <div class="screen-box">
          <div class="screen-label">模板名称</div>

          <a-input
            v-model="r_name"
            allowClear
            placeholder="请输入模板名称"
            style="width: 240px"
          />
        </div>

        <div class="screen-box">
          <div class="screen-label">模板标签</div>
          <a-select
            show-search
            style="min-width: 200px"
            placeholder="请选择模板标签"
            @change="handleChangeB"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            allowClear
          >
            <a-select-option
              v-for="(item, index) in tagSelect"
              :key="item.id"
              :value="item.id"
            >
              {{ item.tag_name }}
            </a-select-option>
          </a-select>
        </div>
        <div class="screen-box">
          <div class="screen-label">模板属性</div>
          <a-select
            style="min-width: 200px"
            placeholder="请选择模板属性"
            :getPopupContainer="getsPopupContainer"
            v-model="r_temp_type"
            allowClear
          >
            <a-select-option :value="1"> H5 </a-select-option>
            <a-select-option :value="2"> H5+小程序 </a-select-option>
            <a-select-option :value="3"> 小程序 </a-select-option>
          </a-select>
        </div>

        <div class="screen-box">
          <div class="screen-label">创建人</div>
          <a-select
            show-search
            style="min-width: 200px"
            placeholder="请选择创建人"
            @change="handleChangeC"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            allowClear
          >
            <a-select-option
              v-for="(value, key) in userSelect"
              :key="key"
              :value="key"
            >
              {{ value }}
            </a-select-option>
          </a-select>
        </div>
        <!--  -->
        <div class="screen-box">
          <div class="screen-label">模板状态</div>

          <!-- @change="handleChangeT" -->
          <a-select
            show-search
            style="min-width: 200px"
            placeholder="请选择模板状态"
            allowClear
            v-model="r_status"
          >
            <a-select-option
              v-for="item in templateType"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </div>
        <!-- 是否置顶 -->
        <div class="screen-box">
          <div class="screen-label">是否置顶</div>

          <!-- @change="handleChangeT" -->
          <a-select
            show-search
            style="min-width: 200px"
            placeholder="请选择置顶状态"
            allowClear
            v-model="r_weight"
          >
            <a-select-option
              v-for="item in weightTemplateType"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </div>

        <a-button
          class="screen-box"
          @click="searchButton('button')"
          :loading="search_button_loading"
          type="primary"
          icon="search"
          >搜索</a-button
        >
        <a-button class="screen-box" @click="goAdd" type="primary" icon="plus"
          >新建</a-button
        >
      </div>
    </div>

    <div style="background-color: #fff; padding: 20px 0 30px 20px">
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div v-for="(item, index) in rableTitle" :key="index">
          <div class="table-th-cell" :style="{ width: item.width + 'px' }">
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <template v-for="(z_tem, z_ndex) in rableTitle">
          <div
            v-if="
              z_tem.type != 'cz' &&
              z_tem.type != 'gzh_count' &&
              z_tem.type != 'status' &&
              z_tem.type != 'weight' &&
              z_tem.type != 'type'
            "
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] }}
          </div>

          <div
            v-else-if="z_tem.type == 'gzh_count'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            {{ item[z_tem.type] }}
            <div
              v-if="item[z_tem.type] > 0"
              @click="wxTdCz(2, item)"
              class="cz-cell"
              style="margin-left: 10px"
            >
              查看
            </div>
          </div>
          <div
            v-else-if="z_tem.type == 'cz'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            <div @click="wxTdCz(1, item)" class="cz-cell">查看详情</div>
          </div>

          <div
            v-else-if="z_tem.type == 'type'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            <span>{{ item.type | filterType }}</span>
          </div>
          <div
            v-else-if="z_tem.type == 'status'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            <a-switch
              :key="`${item.id}_`"
              :checked-value="1"
              :unchecked-value="0"
              @change="switchChange($event, item)"
              :checked="item.status"
            />
          </div>

          <div
            v-else-if="z_tem.type == 'weight'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            <a-switch
              :key="`${item.id}_`"
              :checked-value="1"
              :unchecked-value="0"
              @change="weightChange($event, item)"
              :checked="item.weight"
            />
          </div>
        </template>
      </div>

      <!-- 表格内容为空时显示 -->
      <!-- <tableNull :tableShowData="tableShowData" :table_null_width="table_null_width"></tableNull> -->
      <div
        v-show="tableShowData.length === 0"
        style="text-align: center; margin: 80px 0 50px"
        :style="{ width: table_null_width + 'px' }"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />
        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
      </div>
      <div
        style="
          position: fixed;
          right: 0;
          bottom: 0;
          z-index: 6;
          background-color: #f0f2f5;
          height: calc(100vh - 65px);
          width: 20px;
        "
      ></div>
      <div
        style="
          position: fixed;
          left: 0;
          bottom: 0;
          z-index: 6;
          background-color: #f0f2f5;
          height: calc(100vh - 65px);
          width: 20px;
        "
      ></div>

      <!-- 分页 -->
      <pagingCompont
        :table_scroll_width="table_scroll_width"
        :table_null_width="table_null_width"
        :r_page="r_page"
        :r_limit="r_limit"
        :table_total="table_total"
        @pagination-Change="paginationChange"
        @change-size-limit="changeSizeLimit"
      ></pagingCompont>
    </div>

    <a-drawer
      title="查看公众号"
      width="600px"
      placement="right"
      :closable="false"
      :visible="gzh_visible"
      @close="onCloseDrawer"
    >
      <div style="margin-bottom: 20px">
        <a-input-search
          placeholder="搜索公众号"
          style="width: 300px"
          @search="searchGzhInput($event)"
        />
      </div>
      <div style="display: flex; flex-wrap: wrap">
        <!-- <div v-for="item in tempGzhList" class="gzh-cell" @click="goGzhInfo(item)">{{item.gzh_name}}、</div> -->
        <a-button
          v-for="item in tempGzhList"
          size="small"
          class="gzh-cell"
          @click="goGzhInfo(item)"
        >
          {{ item.gzh_name }}
        </a-button>
      </div>
    </a-drawer>

    <!-- 加载中 -->
    <div class="loading-box" v-if="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import {
  templateTagList,
  templateSelect,
  logSelectUser,
  templateList,
  templateGzhList,
  templateEditApi,
} from "@/request/api";
export default {
  name: "gzhConfigList_",
  components: {},
  data() {
    return {
      tagSelect: [],
      templateSelect: [],
      userSelect: {},
      templateType: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "显示",
          value: 1,
        },
        {
          text: "隐藏",
          value: 0,
        },
      ],
      weightTemplateType: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "置顶",
          value: 1,
        },
        {
          text: "不置顶",
          value: 0,
        },
      ],
      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "模板ID", width: 100, type: "id" },
        { title: "模板名称", width: 200, type: "name" },
        { title: "标签", width: 150, type: "tags_list" },
        { title: "模板属性", width: 150, type: "type" },
        { title: "配置公众号数量", width: 120, type: "gzh_count" },
        { title: "状态", width: 130, type: "status" },
        { title: "是否置顶", width: 130, type: "weight" },
        { title: "操作", width: 130, type: "cz" },
        { title: "创建人", width: 150, type: "admin_name" },
      ],
      tableShowData: [],
      table_scroll_width: 1000,
      table_null_width: 1000,

      search_button_loading: false,

      r_page: 1, // 页数
      r_limit: 50, // 每页多少条
      table_total: 0, // 表格内容总数

      r_name: null, // 模板
      r_tag_id: undefined, // 模板标签
      r_admin_id: undefined, // 创建人
      r_status: 1, // 模板状态
      r_weight: "", //置顶状态
      gzh_visible: false,
      tempGzhList: [],
      tempGzhListSave: [],
      r_temp_type: undefined,
    };
  },
  mounted() {
    let that = this;
    that.search_button_loading = true;

    // 获取表格信息
    let table_info = this.$getTableInfo(that.rableTitle);
    that.body_width = table_info.body_width;
    that.table_scroll_width = table_info.table_width - 30;
    that.table_null_width = table_info.null_width - 30;

    logSelectUser().then((res) => {
      // console.log("获取用户下拉",res);
      that.userSelect = res.data.data.list;
    });

    templateSelect().then((res) => {
      // console.log("模板下拉",res.data.data.list);
      that.templateSelect = res.data.data.list;
    });

    templateTagList().then((res) => {
      // console.log("标签",res);
      that.tagSelect = res.data.data.data;
    });

    that.searchButton();
  },
  filters: {
    filterType(val) {
      const _map = {
        1: `H5`,
        2: `H5+小程序`,
        3: `小程序`,
      };
      return _map[Number(val) || 1];
    },
  },
  methods: {
    async editSwtich(params) {
      try {
        this.search_button_loading = true;
        const {
          data: { code, msg },
        } = await templateEditApi({
          ...params,
        });
        if (code === 0) {
          this.$message.success(`修改成功`);
          this.searchButton();
        } else {
          if (msg) {
            this.$message.error(msg);
            this.searchButton();
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.search_button_loading = false;
      }
    },
    async switchChange(e, item) {
      const status = e ? 1 : 0;
      const id = item.id;
      if (this.search_button_loading) {
        return;
      }
      await this.editSwtich({
        id,
        status,
      });
    },
    async weightChange(e, item) {
      const weight = e ? 1 : 0;
      const id = item.id;
      if (this.search_button_loading) {
        return;
      }
      await this.editSwtich({
        id,
        weight,
      });
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeA(e) {
      this.r_name = e;
    },
    handleChangeB(e) {
      // console.log("模板标签",e);
      this.r_tag_id = e;
    },
    handleChangeC(e) {
      // console.log("创建人",e);
      this.r_admin_id = e;
    },
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;
      if (type == "button") {
        this.r_page = 1;
      }
      templateList({
        page: this.r_page,
        limit: this.r_limit,
        name: this.r_name,
        tag_id: this.r_tag_id,
        admin_id: this.r_admin_id,
        status: this.r_status,
        weight: this.r_weight,
        type: this.r_temp_type,
      }).then((res) => {
        // console.log("列表数据",res);
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.tableShowData = res.data.data.data.map((item) => {
            return {
              ...item,
              status: Boolean(item.status),
            };
          });
          that.table_total = res.data.data.total;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 分页
    paginationChange(e) {
      let that = this;
      this.r_page = e;
      this.searchButton();
    },
    changeSizeLimit(e) {
      // console.log('每页多少条',e)
      this.r_limit = e;
      this.searchButton("button");
    },

    wxTdCz(type, item) {
      let that = this;
      if (type == 1) {
        // 查看详情
        const { href } = this.$router.resolve({
          path: "/gzhConfigTemplate",
          query: { info_id: item.id },
        });

        window.open(href, "_blank");
      } else if (type == 2) {
        this.gzh_visible = true;
        templateGzhList({
          id: item.id,
        }).then((res) => {
          that.tempGzhList = res.data.data.list;
          that.tempGzhListSave = res.data.data.list;
        });
      }
    },

    goAdd() {
      // 新建
      const { href } = this.$router.resolve({
        path: "/gzhConfigTemplate",
        query: {},
      });

      window.open(href, "_blank");
    },

    onCloseDrawer() {
      this.gzh_visible = false;
    },

    goGzhInfo(item) {
      console.log("item", item);

      const { href } = this.$router.resolve({
        path: "/menuManagement",
        query: {
          g_id: item.gzh_id,
          c_id: item.channel_id,
        },
      });
      window.open(href, "_blank");
    },
    searchGzhInput(e) {
      console.log("e", e);
      let that = this;
      if (e) {
        let s_data = [];
        that.tempGzhListSave.forEach((res) => {
          if (res.gzh_name.indexOf(e) > -1) {
            s_data.push(res);
          }
        });
        that.tempGzhList = s_data;
      } else {
        that.tempGzhList = that.tempGzhListSave;
      }
    },
  },
};
</script>

<style scoped>
.page-box {
  background-color: rgb(240, 242, 245);
  margin: -20px -30px -30px -30px;
  padding: 20px 30px 0 20px;
  min-height: calc(100vh - 65px);
}

/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 12px;
  /* margin-bottom: 5px; */
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}

.gzh-cell {
  cursor: pointer;
  margin-right: 15px;
  margin-bottom: 12px;
}
.gzh-cell:hover {
  color: #62a8ea;
}
</style>
